// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AvatarList_wrapper","active-item":"AvatarList_active-item","activeItem":"AvatarList_active-item","details":"AvatarList_details"};